import { Component } from '@angular/core';

@Component({
  selector: 'wpro-spinner-default',
  templateUrl: 'spinner-default.component.html',
  standalone: false
})
export class SpinnerDefaultComponent {
}
